import { render, staticRenderFns } from "./visualize-results.vue?vue&type=template&id=24f77a52&scoped=true&"
import script from "./visualize-results.vue?vue&type=script&lang=js&"
export * from "./visualize-results.vue?vue&type=script&lang=js&"
import style0 from "./visualize-results.vue?vue&type=style&index=0&id=24f77a52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f77a52",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CFlex: require('@chakra-ui/vue').CFlex, CBox: require('@chakra-ui/vue').CBox})
